export { default } from './InformationSection';
